// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Editor_wrapper","counter":"Editor_counter","loader":"Editor_loader"};